
import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';
import { VariazioneDaComunicare, TipoVariazione, VariazioneDaComunicareQtaTaglia } from '@/models';

@Component
export default class TabellaValori extends Vue {
  @PropSync('rigaDistinta') private riga!: VariazioneDaComunicare;
  private tipoVariazione = TipoVariazione;

  inputTextFieldCambiato(num: string) {
    if (this.isValidFieldNumber(num) && this.hasAllValidElements()) {
      this.riga.valida = true;
    } else {
      this.riga.valida = false;
    }
  }

  private hasAllValidElements(): boolean {
    return this.riga.variazioneRigaDistintaQtaTaglia.every(
      (variazione: VariazioneDaComunicareQtaTaglia) =>
        this.isValidFieldNumber(variazione.qtaModificata?.toString())
    );
  }

  private isValidFieldNumber(num: string) {
    return !isNaN(parseFloat(num)) && parseFloat(num) >= 0;
  }
}
